<template>
  <div class="column content-box template-picker">
    <woot-modal-header
      :header-title="
        $t('INTEGRATION_SETTINGS.ASSISTENT.ADD.TEMPLATES_MODAL.TITLE')
      "
    />

    <div class="templates-grid">
      <div
        v-for="template in templates"
        :key="template.id"
        class="template-card"
        :class="{
          'template-card--selected': selectedTemplateId === template.id,
        }"
        @click="selectTemplate(template.id)"
      >
        <div class="template-card-header">
          <img
            :src="template.avatar"
            :alt="template.name"
            class="template-avatar"
          />
          <div class="template-card-titles">
            <h4 class="template-name">{{ template.name }}</h4>
            <span class="template-category">{{ template.category }}</span>
          </div>
        </div>
        <div
          v-dompurify-html="template.description"
          class="template-description"
        />
      </div>
    </div>

    <div class="modal-footer footer-actions">
      <div class="medium-12 columns box-actions">
        <p
          v-dompurify-html="
            $t('INTEGRATION_SETTINGS.ASSISTENT.ADD.TEMPLATES_MODAL.NOTE')
          "
          class="template-note"
        />
        <woot-button
          :disabled="!selectedTemplateId || isSubmitting"
          :is-loading="isSubmitting"
          @click="confirmSelection"
        >
          {{
            $t('INTEGRATION_SETTINGS.ASSISTENT.ADD.TEMPLATES_MODAL.BUTTON_USE')
          }}
        </woot-button>
      </div>
    </div>
  </div>
</template>

<script>
import templates from '../virtualAssistentsTemplates';

export default {
  props: {
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      templates,
      selectedTemplateId: null,
    };
  },
  methods: {
    selectTemplate(id) {
      this.selectedTemplateId = id;
    },
    confirmSelection() {
      const template = this.templates.find(
        t => t.id === this.selectedTemplateId
      );
      if (!template) return;
      this.$emit('select-template', template);
    },
  },
};
</script>

<style scoped lang="scss">
.template-picker {
  display: flex;
  flex-direction: column;
}

.templates-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: var(--space-normal);
  padding: 0 var(--space-normal) var(--space-normal);
}

.template-card {
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius-normal);
  padding: var(--space-normal);
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  display: grid;
  grid-template-rows: subgrid;
  grid-row: span 2;

  &:hover {
    border-color: var(--color-woot);
  }

  &--selected {
    border-color: var(--color-woot);
    box-shadow: 0 0 0 1px var(--color-woot);
    background-color: var(--w-25);
  }
}

.template-card-header {
  display: flex;
  align-items: flex-start;
  gap: var(--space-small);
  margin-bottom: var(--space-small);
}

.template-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.template-card-titles {
  display: flex;
  flex-direction: column;
}

.template-name {
  margin: 0;
  font-size: var(--font-size-medium);
  font-weight: var(--font-weight-bold);
  color: var(--s-900);
}

.template-category {
  font-size: var(--font-size-mini);
  color: var(--s-500);
}

.template-description {
  font-size: var(--font-size-small);
  color: var(--s-700);

  ::v-deep ul {
    margin: var(--space-smaller) 0 0 var(--space-normal);
    padding: 0;
  }
}

.footer-actions {
  display: flex;
  flex: 1;
  padding: 0 var(--space-normal) var(--space-normal);

  .box-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.template-note {
  color: var(--s-500);
  font-size: var(--font-size-small);
  max-width: 60%;
  margin: 0;

  ::v-deep strong {
    color: var(--s-700);
  }
}
</style>
